import { Component } from '@angular/core';
import { AssemblyBrandsService } from '../../../../Services/Assembly-Brands/assembly-brands.service';
import { NotificationService } from '../../../../Services/notification.service';
import { NavbarService } from '../../../../Services/navbar.service';
import { FormsModule } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';

@Component({
  selector: 'app-assembly-brand',
  imports: [FormsModule, NgIf, NgFor],
  templateUrl: './assembly-brand.component.html',
  styleUrl: './assembly-brand.component.css'
})
export class AssemblyBrandComponent {

  newBrandName: string = '';
  brandList: any[] = [];
  isLoading = true;
// Pagination
currentPage: number = 1;
itemsPerPage: number = 10;
totalPages: number = 1;
paginatedBrandList: any[] = [];

  constructor(
    private assemblyBrandService: AssemblyBrandsService,
    private notificationService: NotificationService,
    private navbarService: NavbarService,
  ) {
    this.getBrands();
  }

  allowOnlyLetters(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
      'Space'
    ];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Allow only letters and spaces
    const regex = /^[a-zA-Z\s]$/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  sanitizeBrandName() {
    // Remove numbers & special characters if pasted
    this.newBrandName = this.newBrandName.replace(/[^a-zA-Z\s]/g, '');
  }


  saveBrandName() {
    if (!this.newBrandName.trim()) {
      this.notificationService.showError('Brand name is required.', 'Validation');
      return;
    }

    if (/\d/.test(this.newBrandName)) {
      this.notificationService.showError('Brand name cannot contain numbers.', 'Validation');
      return;
    }

    const payload = {
      assembly_brand_name: this.newBrandName.trim()
    };

    this.assemblyBrandService.createAssemblyBrand(payload).subscribe({
      next: () => {
        this.notificationService.showSuccess(
          `Brand "${this.newBrandName}" added successfully.`,
          'success'
        );
        this.newBrandName = '';
        this.getBrands();
      },
      error: (err) => {
        this.notificationService.showError('Failed to save brand.', 'Add Brand');
        console.error('Add brand error:', err);
      }
    });
  }

  getBrands() {
    this.assemblyBrandService.getAssemblyBrands().subscribe({
      next: (response: any) => {
        this.brandList = response.data.reverse();
        this.isLoading = false;
        this.currentPage = 1;
      this.updatePagination();
      },
      error: (err) => {
        console.error('Fetch brands error:', err);
        this.isLoading = false;
      }
    })
  }
  updatePagination() {
    this.totalPages = Math.ceil(this.brandList.length / this.itemsPerPage) || 1;

    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    this.paginatedBrandList = this.brandList.slice(start, end);
  }

  goToPage(page: number | string) {
    if (typeof page === 'string') return;
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.updatePagination();
    }
  }

  get pageNumbers(): (number | string)[] {
    const totalPages = this.totalPages;
    const currentPage = this.currentPage;
    const maxPagesToShow = 5;
    const pages: (number | string)[] = [];

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) {
        pages.push('...');
      }
      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 2) {
        startPage = 2;
        endPage = 3;
      }
      if (currentPage >= totalPages - 1) {
        startPage = totalPages - 2;
        endPage = totalPages - 1;
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) {
        pages.push('...');
      }
      pages.push(totalPages);
    }
    return pages;
  }
  deleteBrang(id: any) {
    this.assemblyBrandService.deleteAssemblyBrand(id).subscribe({
      next: () => {
        this.notificationService.showSuccess(`Brand Deleted successfully.`, 'success');
        // this.navbarService.getBrands();
        this.getBrands();
      },
      error: (err) => {
        this.notificationService.showError('Failed to Delete brand.', 'Delete Brand');
        console.error('Delete brand error:', err);
      }
    })
  }
}
